import React, { useState, useEffect } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {
  Box,
  Button,
  FormControl,
  OutlinedInput,
  Typography,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../apiConfig";

function AdminLogin() {
  const [userInput, setUserInput] = useState({
    UserName: "",
    PassWord: "",
  });
  const [rememberMe, setRememberMe] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const navigate = useNavigate();
  const maxAttempts = 5; // الحد الأقصى للمحاولات

  useEffect(() => {
    const savedUserName = localStorage.getItem("userName");
    const savedPassWord = localStorage.getItem("passWord");
    const savedAttempts = localStorage.getItem("loginAttempts") || 0;
    const savedBlockTime = localStorage.getItem("blockUntil");

    if (savedUserName && savedPassWord) {
      setUserInput({
        UserName: savedUserName,
        PassWord: savedPassWord,
      });
      setRememberMe(true);
    }

    // setAttempts(parseInt(savedAttempts, 10));

    // if (savedBlockTime && new Date() < new Date(savedBlockTime)) {
    //   setErrorMessage("تم حجب الدخول مؤقتًا. حاول مرة أخرى لاحقًا.");
    // }
  }, []);

  const handleLogin = async () => {
    // if (attempts >= maxAttempts) {
    //   setErrorMessage("تم حجب الدخول مؤقتًا. حاول مرة أخرى لاحقًا.");
    //   return;
    // }

    if (!userInput.UserName || !userInput.PassWord) {
      setErrorMessage("يرجى إدخال اسم المستخدم وكلمة المرور.");
      return;
    }

    setErrorMessage("");
    setIsLoading(true);

    try {
      const response = await axios.post(`${API_BASE_URL}Auth/login`, {
        userName: userInput.UserName,
        password: userInput.PassWord,
      });

      const token = response.data.accessToken;
      const refresh = response.data.refreshToken;

      localStorage.setItem("token", token);
      localStorage.setItem("refresh", refresh);
      // document.cookie = `token=${token}; path=/; Secure; SameSite=Strict`;

      if (rememberMe) {
        localStorage.setItem("userName", userInput.UserName);
        localStorage.setItem("passWord", userInput.PassWord);
      } else {
        localStorage.removeItem("userName");
        localStorage.removeItem("passWord");
      }

      // localStorage.setItem("userID", response.data.id);

      setIsLoading(false);
      setAttempts(0); // Reset attempts after successful login
      localStorage.setItem("loginAttempts", 0);
      navigate("/admin", { replace: true });
    } catch (error) {
      setIsLoading(false);
      const newAttempts = attempts + 1;
      setAttempts(newAttempts);
      localStorage.setItem("loginAttempts", newAttempts);

      if (newAttempts >= maxAttempts) {
        const blockUntil = new Date(new Date().getTime() + 5 * 60 * 1000);
        localStorage.setItem("blockUntil", blockUntil);
        setErrorMessage("تم حجب الدخول مؤقتًا. حاول مرة أخرى لاحقًا.");
      } else {
        const remainingAttempts = maxAttempts - newAttempts;
        setErrorMessage(
          `فشل في تسجيل الدخول. تبقى ${remainingAttempts} محاولات.`,
        );
      }
    }
  };

  const handleCheck = (event) => {
    setRememberMe(event.target.checked);
  };

  if (isLoading) {
    return (
      <div
        style={{
          background: "#272727",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        ..جاري التحميل
      </div>
    );
  }

  return (
    <div dir="rtl">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#272727",
          position: "relative",
        }}
      >
        <div style={{ marginBottom: "22px" }}>
          <img
            src="/logo.png"
            width="170"
            height="auto"
            alt="كوبونات أول طلب"
          />
        </div>
        <Box
          sx={{
            backgroundColor: "#333",
            padding: 3,
            borderRadius: 2,
            textAlign: "center",
            boxShadow: 3,
            maxWidth: 300,
            width: "100%",
          }}
        >
          <LockIcon
            sx={{
              fontSize: 50,
              color: "#fff",
              marginBottom: 2,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />

          <Typography variant="h6" sx={{ color: "#fff", marginBottom: 2 }}>
            دخول لوحة التحكم
          </Typography>

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <OutlinedInput
              value={userInput.UserName}
              onChange={(e) =>
                setUserInput({ ...userInput, UserName: e.target.value })
              }
              placeholder="اسم المستخدم"
              sx={{
                color: "#fff",
                backgroundColor: "#5b5b5c",
                borderRadius: "4px",
                "& input": { color: "#fff" },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#fff" },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#fff",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#fff",
                },
              }}
            />
          </FormControl>

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <OutlinedInput
              value={userInput.PassWord}
              onChange={(e) =>
                setUserInput({ ...userInput, PassWord: e.target.value })
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleLogin();
                }
              }}
              placeholder="كلمة المرور"
              type="password"
              sx={{
                color: "#fff",
                backgroundColor: "#5b5b5c",
                borderRadius: "4px",
                "& input": { color: "#fff" },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#fff" },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#fff",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#fff",
                },
              }}
            />
          </FormControl>

          {errorMessage && (
            <Typography variant="body2" color="error" sx={{ marginBottom: 2 }}>
              {errorMessage}
            </Typography>
          )}

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ marginTop: 1, backgroundColor: "green" }}
            onClick={handleLogin}
            disabled={attempts >= maxAttempts} // تعطيل الزر عند الحجب
          >
            دخول
          </Button>

          <div
            style={{
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              marginTop: "10px",
              padding: "0",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={handleCheck}
                  sx={{
                    color: "white",
                    "&.Mui-checked": { color: "white" },
                    padding: "0",
                    marginLeft: "5px",
                  }}
                />
              }
              label="تذكرني"
              sx={{ color: "#fff", margin: "0", padding: "2px" }}
            />
          </div>
        </Box>

        <Typography
          variant="body2"
          sx={{
            position: "absolute",
            bottom: 10,
            left: 10,
            color: "#e6e6e6",
          }}
        >
          كوبون أول طلب
        </Typography>
      </Box>
    </div>
  );
}

export default AdminLogin;
